import React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import UserNameEmailConnectorApollo from '@dietlabs/components/src/ApolloConnectors/Contact/Fetch/UserNameEmailConnectorApollo';
import ContentConnectorApollo from '@dietlabs/components/src/ApolloConnectors/Content/ContentConnectorApollo';
import SendEmailConnectorApollo from '@dietlabs/components/src/ApolloConnectors/Contact/SendEmailConnectorApollo';
import ContactContainer from './ContactContainer';

const recaptchaKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '';

class ContactPage extends React.Component {
    static propTypes = {};

    render() {
        return (
            <ContentConnectorApollo identifier="faq:dietitian">
                {({ ...contentData }) => (
                    <UserNameEmailConnectorApollo>
                        {({ ...userData }) => (
                            <SendEmailConnectorApollo>
                                {({ contactEmail }) => (
                                    <GoogleReCaptchaProvider
                                        reCaptchaKey={recaptchaKey}
                                    >
                                        <ContactContainer
                                            content={contentData.content}
                                            userData={userData.userData}
                                            loading={
                                                contentData.loading ||
                                                userData.loading
                                            }
                                            contactEmail={contactEmail}
                                        />
                                    </GoogleReCaptchaProvider>
                                )}
                            </SendEmailConnectorApollo>
                        )}
                    </UserNameEmailConnectorApollo>
                )}
            </ContentConnectorApollo>
        );
    }
}

export default ContactPage;
